// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"da51a739f7--avatar--ceW9Q","border":"da51a739f7--border--auYzs","clickable":"da51a739f7--clickable--jjxbB","company":"da51a739f7--company--MXKHY"};